/**
 * Regra de qual tabela de preço vale para um orçamento/pedido.
 *
 * A tabela vem do representante: condições de pagamento à vista / curto prazo
 * usam repres.codtab1; qualquer outra usa repres.codtab2. Sem representante ou
 * com o campo vazio não há tabela - nada é bloqueado nem reprecificado e o item
 * novo entra pelo maior preço cadastrado. Com a tabela definida, o preço
 * unitário vem de prodpreco.
 *
 * Mantido em sincronia com App\Services\TabelaPrecoService no backend, que é
 * quem valida de fato na gravação do item.
 */

export const CONDICOES_TABELA_PADRAO = [
  "A VISTA",
  "A VISTA 7 DIAS",
  "A VISTA C 7 DIA",
  "14 DIAS",
  "7 E 14",
  "7 14",
  "10 DIAS",
];

export const ORIGEM_REPRES_PADRAO = "repres.codtab1";
export const ORIGEM_REPRES_ALTERNATIVA = "repres.codtab2";

/**
 * Normaliza a descrição da condição para comparação: maiúsculas, sem acento e
 * sem espaços duplicados. Assim "À Vista" e "a  vista" caem na mesma chave.
 */
export function normalizaDescricaoCondPgto(descricao) {
  if (!descricao) {
    return "";
  }

  return descricao
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
}

/**
 * Indica se a condição de pagamento usa a tabela padrão do cliente.
 */
export function usaTabelaPadrao(descricaoCondPgto) {
  return CONDICOES_TABELA_PADRAO.includes(
    normalizaDescricaoCondPgto(descricaoCondPgto)
  );
}

/**
 * Resolve a tabela de preço a partir dos dados de cliente, condição de pagamento
 * e (opcional) representante já carregados na tela.
 *
 * @returns {{ok: boolean, tabpreco: ?string, origem: ?string, motivo: ?string}}
 */
export function resolveTabelaPreco(clienteData, condPgtoData, represData = null) {
  const resultado = {
    ok: false,
    tabpreco: null,
    origem: null,
    motivo: null,
  };

  if (!clienteData || !clienteData.id) {
    resultado.motivo = "Selecione o cliente antes de incluir itens.";
    return resultado;
  }

  if (!condPgtoData || !condPgtoData.id) {
    resultado.motivo =
      "Selecione a condição de pagamento antes de incluir itens: ela define qual tabela do representante será usada.";
    return resultado;
  }

  const usaPadrao = usaTabelaPadrao(condPgtoData.descricao);

  // sem representante ou sem o campo da condição: sem tabela, e isso não bloqueia
  const tabRepres = represData
    ? (represData[usaPadrao ? "codtab1" : "codtab2"] || "").trim()
    : "";
  if (tabRepres) {
    resultado.origem = usaPadrao ? ORIGEM_REPRES_PADRAO : ORIGEM_REPRES_ALTERNATIVA;
    resultado.tabpreco = tabRepres;
  }

  resultado.ok = true;
  return resultado;
}
